import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('netsuite_custom_form_id'),
    subtitle: defineMessage('by_default_approvalmax__d_for_this_organization'),
    placeholder: defineMessage('enter_netsuite_form_id'),
};
